<script>
    import TinyPumperFleetGrid from '@/components/tinyPumper/TinyPumperFleetGrid';

    export default {
        name: 'TinyPumper',
        components: {
            TinyPumperFleetGrid
        }
    };
</script>

<template>
    <div class="main-content-header">
        <h3>
            <i class="bi-plugin"></i>
            Tiny Pumper Dashboard
        </h3>
    </div>
    <div class="main-content-body">
        <TinyPumperFleetGrid />
    </div>
</template>
